export default __webpack_public_path__ + "static/media/LoginIllustration.0d5afba3.svg";